import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireProfile = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--mep-black)]">
        <div className="text-[var(--mep-gold)] font-display text-sm tracking-[0.3em] uppercase">Cargando...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.payment_status !== "paid") return <Navigate to="/pago" replace />;
  if (requireProfile && !user.has_profile) return <Navigate to="/crear-perfil" replace />;
  return children;
}
